<template>

    <v-step :step="step" title="Settings">
        <v-form-group label="Layout" caption="The layout of the form elements.">
            <v-select class="w-300" :model="form.layout" @input="setParam({ layout: $event })">
                <option value="hor">Horizontal</option>
                <option value="ver">Vertical</option>
            </v-select>
        </v-form-group>
        <v-form-group label="Font" caption="The font for all labels and inputs.">
            <v-select-font class="w-300" :model="form.font_family" @input="setParam({ font_family: $event })" />
        </v-form-group>
        <v-form-group label="Button Label" caption="The submit button text.">
            <v-input class="w-300" :model="form.button_label" @input="setParam({ button_label: $event })" />
        </v-form-group>
        <v-form-group label="Tag Name" caption="All leads who submit the form will be tagged with this.">
            <v-input class="w-300" :model="form.tag_name" @input="setParam({ tag_name: $event })" />
        </v-form-group>
        <v-form-group label="Success Message" caption="The message shown after the form is submitted.">
            <v-textarea :model="form.success_message" @input="setParam({ success_message: $event })" />
        </v-form-group>
    </v-step>

</template>

<script>

import Step from './Step';

export default {

    components: {
        'v-step': Step,
    },

    props: {
        step: {
            type: Number,
            default: 1,
        },
    },

    computed: {

        form() {
            return this.$store.getters['form/form'];
        },

    },

    methods: {

        setParam(param) {
            this.$store.commit('form/setParam', param);
        },

    },

}

</script>
